<template>
  <component :is="kind" />
</template>

<script>
  import SimulationsForm from '@sdk/views/Simulations/Form.vue';
  import ProposalsNew from './New.vue';

  export default {
    name: 'ProposalsForm',
    components: {
      SimulationsForm,
      ProposalsNew,
    },
    computed: {
      kind() {
        return [false, 'false'].includes(this.$route.query.integrated) ? 'proposals-new' : 'simulations-form';
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
